import { PostApi101, PostApiLoginLog, PostApi109, PostApi1910, PostApi1913, PostApiGetNewPoint } from "../../modules/network/padoPost";
import { socketManager, SocketCommand, LOG_IN_SUCCESS, MENU_SET_ALL, SET_APP_ALL, SET_USER_HEALTH } from '../../components/AppProvider';
import { setCookie, setCookieWs } from '../../modules/utils/cookie';
import { sha256 } from 'js-sha256';
import { PostApi1902 } from './../../modules/network/padoPost';
import { NativeAction } from "../../modules/utils/HandleWs";
import { SET_MENU_NEW_REPORT_LIST } from './../../components/AppProvider';

export const password = (userId, userPw) => {
  let newPassword = sha256(userId.trim() + "eocs" + userPw);

  return newPassword;
};


export const loginLogInterface = (userinfo, phonecfg, cfg, logType, procType, scrptTypeCd) => {
  if (logType === "I") {
    PostApiLoginLog(userinfo, phonecfg, cfg, logType, procType, scrptTypeCd)
      .then((res) => {
        if (res.resultCode === "000") {
        } else {
        }
      })
      .catch((err) => {
        // handleLoginFail();
      });
  } else {
    PostApi109(userinfo, phonecfg, cfg, logType, procType, scrptTypeCd)
      .then((res) => {
        if (res.resultCode === "000") {
        } else {
        }
      })
      .catch((err) => {
        // handleLoginFail();
      });
  }
};

export const handleRequest101 = (phonecfg, cfg, dispatch, setLoginSuccess, userId, userPw, signUpChannel, handleAlert) => {
  const newPassword = sha256(userId.trim() + "eocs" + userPw);

  PostApi101(phonecfg, cfg, userId.trim(), newPassword, "", signUpChannel)
    .then((res) => {
      if (res.resultCode === "000") {
        setLoginSuccess(true);
        handleLoginSuccess(phonecfg, cfg, dispatch, res, handleAlert);
        setCookie("lastLoginChannel", signUpChannel, 365);
        loginLogInterface(res.result[0], phonecfg, cfg, "I", "M", signUpChannel);
      }
      socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
        login: "in",
        userToken: res.result[0].userToken.toString(),
      });
    })
    .catch((err) => {
      setLoginSuccess(false);
      // handleLoginFail();
    });
};

const requestGetNewPoint = (userinfo, cfg, phonecfg) => {
  PostApiGetNewPoint(userinfo, cfg, phonecfg)
  .then((res) => {
      if (res.resultCode === "E000") {
          dispatch({ type: SET_MENU_NEW_REPORT_LIST, data: res.result });
      } else {
          console.log("Interface Fail");
      }
  })
  .catch((err) => {
      console.log(err);
  });
};

const handleLoginSuccess = (phonecfg, cfg, dispatch, res, handleAlert) => {
  dispatch({
    type: LOG_IN_SUCCESS,
    data: res.result[0],
    isAutoLogin: true,
  });
  
  socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
    login: "in",
    userToken: res.result[0].userToken.toString(),
  });
  
  request1910(phonecfg, cfg, dispatch, res.result[0], "");
  request1913(phonecfg, cfg, dispatch, res.result[0]);
  requestGetNewPoint(res.result[0], cfg, phonecfg);
  setUserHlthInfo(phonecfg, cfg, dispatch, res.result[0]);

  setCookieWs({
    isAutoLogin: true,
    signUpChannel: "000",
    userEmail: res.result[0].userEmail,
  });

  if (
    phonecfg.phoneOS === "IOS" &&
    parseInt(phonecfg.version.split(".")[2]) > 13
  ) {
    NativeAction(phonecfg, "login", "in");
  }

  // 전체 가져오기 수정 필요
  handleAlert("확인", `케어포미에 오신 것을 환영합니다.`, "/");
  // if (res.result[0].isAuthOk == "0") {
  //   // 향후 수정 필요 임시임(DSRYU) 메세지 매번 보여줄 필요 없음 처리
  //   $("#exchangeTargetLogin").attr("id", "welcomeLogin");
  //   handleAlert("확인", `케어포미에 오신 것을 환영합니다.`);
  //   // 로그인 처리는 여기에++++++
  // } else {
  //   // 로그인 이후 본인인증 여부에 따라
  //   $("#exchangeTargetLogin").attr("id", "welcomeLogin");
  //   _O.OpenMenu("/membership/certification");
  // }
};

const setUserHlthInfo = (phonecfg, cfg, dispatch, userinfo) => {
  PostApi1902(userinfo, cfg, dispatch, phonecfg)
    .then((res) => {
      if (res.resultMsg === "SUCCESS") {
        if (res.result) {
          dispatch({ type: SET_USER_HEALTH, data: res.result });
        }
      } else {
        console.log("LOGOUT!!!");
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

const request1910 = (phonecfg, cfg, dispatch, userinfo, cardType) => {
  PostApi1910(userinfo, cfg, phonecfg, cardType)
    .then((res) => {
      if (res.resultMsg === "SUCCESS") {
        let data = res.result;
        if (data.length > 0)
          dispatch({
            type: MENU_SET_ALL,
            menutype: cardType,
            data: data,
          });
      } else {
        console.log("LOGOUT!!!");
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
const request1913 = (phonecfg, cfg, dispatch, userinfo) => {
  PostApi1913(userinfo, cfg, phonecfg)
    .then((res) => {
      if (res.resultMsg === "SUCCESS") {
        let data = res.result;
        dispatch({ type: SET_APP_ALL, data: data });
      } else {
        console.log("LOGOUT!!!");
      }
    })
    .catch((err) => {
      console.log(err);
    });
};